import React, { Component } from "react"
import {
  Card,
  Icon,
  Label,
  Button,
  Table,
  Modal,
  Input,
} from "semantic-ui-react"
import Info from "../components/Info"
import { getOrganizationData } from "../ducks/profile"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import "./css/ProfilePage.css"
import InputMask from "react-input-mask"
import { editProfileApi } from "../config/apiUrls"
import { apiPost } from "../utils/apiConnector"

@connect(
  (state) => ({
    profile: state.profile,
    organization: state.profile.organization,
  }),
  (dispatch) => ({
    getOrganizationData: () => dispatch(getOrganizationData()),
  }),
)
class ProfilePage extends Component {
  state = {
    profile: this.props.profile || {},
    organization: this.props.organization || {},
    edit: true /* this.props.profile
      ? this.props.profile.owner
        ? this.props.profile.owner.Success
        : false
      : false, */,
    inputValue: "",
    modal: <></>,
    oldPassword: "",
    correct: false,
  }

  componentDidMount() {
    this.props.getOrganizationData()
    this.setState({
      profile: this.props.profile,
      organization: this.props.organization,
    })
  }

  componentDidUpdate() {
    if (this.props.organization && this.state.organization) {
      if (
        this.state.organization.fio === this.props.organization.fio &&
        this.props.organization.mail === this.state.organization.mail &&
        this.props.organization.nds === this.state.organization.nds &&
        this.props.organization.phoneNumber ===
          this.state.organization.phoneNumber
      ) {
      } else {
        this.props.getOrganizationData()
        if (this.props.organization.fio) {
          this.setState({
            profile: this.props.profile,
            organization: this.props.organization,
          })
        } else {
          const y = () => {
            if (this.props.organization.fio) {
              this.setState({
                profile: this.props.profile,
                organization: this.props.organization,
              })
            } else setTimeout(y, 10)
          }
          setTimeout(y, 10)
        }
        this.setState({
          profile: this.props.profile,
          organization: this.props.organization,
        })
      }
    } else {
      this.props.getOrganizationData()
    }
    if (this.state.profile) {
      if (this.state.profile.stores) {
        if (
          this.state.profile.stores.length !== this.props.profile.stores.length
        ) {
          this.setState({
            profile: this.props.profile,
            organization: this.props.organization,
          })
        }
      }
    }
  }

  drawModal = (ed) => {
    const { t } = this.props
    this.setState({
      modal: (
        <Modal
          open={true}
          onClose={() => {
            this.setState({ modal: <></> })
          }}
          size="mini"
          style={{ height: "max-content", marginTop: "-30vh" }}
        >
          <Modal.Header>{t("edit") + " " + t(ed)}</Modal.Header>
          <Modal.Content>
            {ed === "nds"
              ? this.ndsInput()
              : ed === "mail"
              ? this.mailInput()
              : ed === "phoneNumber"
              ? this.phoneNumberInput()
              : ed === "comment"
              ? this.commentInput()
              : ed === "password"
              ? this.passwordInput()
              : ""}
            <p></p>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Button
                positive
                content={t("save")}
                onClick={() => {
                  const data = {}
                  data[ed] = this.state.inputValue
                  this.editProfile(data)
                  this.setState({ inputValue: "", modal: <></> })
                  this.props.getOrganizationData()
                  if (this.props.organization) {
                    this.setState({
                      profile: this.props.profile,
                      organization: this.props.organization,
                    })
                  }
                }}
              />
              <Button
                content={t("cancel")}
                onClick={() => {
                  this.setState({ modal: <></>, inputValue: "" })
                }}
              />
            </div>
          </Modal.Content>
        </Modal>
      ),
    })
  }

  editProfile = (data) => {
    apiPost(editProfileApi, data)
      .onOk((res) => {
        console.log(res.data.response)
      })
      .start()
  }

  ndsInput = () => {
    return (
      <InputMask
        mask="99999 999999999"
        maskChar={""}
        onChange={(e) => {
          this.setState({ inputValue: e.target.value })
        }}
      >
        {(inputProps) => <Input {...inputProps} />}
      </InputMask>
    )
  }

  passwordInput = () => {
    const { t } = this.props
    return (
      <>
        <div>
          <div>
            <a style={{ display: "block", color: "black" }}>
              {t("Old password")}:
            </a>
            <Input
              type="password"
              onChange={(e, d) => {
                document.getElementById("icon-check").style.display =
                  "inline-block"
                document.getElementById("icon-check-x").style.display = "none"
                this.setState({ oldPassword: d.value })
              }}
            />
            <span style={{ display: "inline-block", width: 5 }}></span>
            <Icon
              name="check"
              color="green"
              id="icon-check"
              style={{ display: "none" }}
            />
            <Icon
              name="close"
              color="red"
              id="icon-check-x"
              style={{ display: "inline-block" }}
            />
            <p></p>
            <p></p>
          </div>
          <div>
            <a style={{ display: "block", color: "black" }}>
              {t("New password")}:
            </a>
            <Input
              type="password"
              onChange={(e, d) => {
                document.getElementById("icon-check-1").style.display =
                  "inline-block"
                document.getElementById("icon-check-1-x").style.display = "none"
                this.setState({ inputValue: d.value })
              }}
            />
            <span style={{ display: "inline-block", width: 5 }}></span>
            <Icon
              name="check"
              color="green"
              id="icon-check-1"
              style={{ display: "none" }}
            />
            <Icon
              name="close"
              color="red"
              id="icon-check-1-x"
              style={{ display: "inline-block" }}
            />
            <p></p>
            <p></p>
          </div>
          <div>
            <a style={{ display: "block", color: "black" }}>
              {t("Repeat new password")}:
            </a>
            <Input
              type="password"
              error={false}
              onChange={(e, d) => {
                if (d.value === this.state.inputValue) {
                  document.getElementById("icon-check-2").style.display =
                    "inline-block"
                  document.getElementById("icon-check-2-x").style.display =
                    "none"
                  this.setState({ correct: true })
                }
              }}
            />
            <span style={{ display: "inline-block", width: 5 }}></span>
            <Icon
              name="check"
              color="green"
              id="icon-check-2"
              style={{ display: "none" }}
            />
            <Icon
              name="close"
              color="red"
              id="icon-check-2-x"
              style={{ display: "inline-block" }}
            />
            <p></p>
            <p></p>
          </div>
        </div>
      </>
    )
  }

  mailInput = () => {
    return (
      <Input
        type="email"
        onChange={(e) => {
          this.setState({ inputValue: e.target.value })
        }}
      />
    )
  }

  phoneNumberInput = () => {
    return (
      <InputMask
        mask="+7 (999) 999 99 99"
        maskChar={""}
        onChange={(e) => {
          const r = e.target.value
            ? parseInt(
                e.target.value
                  .split(" ")
                  .join("")
                  .split("(")[1]
                  .split(")")
                  .join("")
                  .split("+")
                  .join(""),
              )
            : ""
          this.setState({ inputValue: r })
        }}
      >
        {(inputProps) => <Input {...inputProps} />}
      </InputMask>
    )
  }

  commentInput = () => {
    return (
      <Input
        onChange={(e) => {
          this.setState({ inputValue: e.target.value })
        }}
      />
    )
  }

  render() {
    console.log(this.state.correct)
    const { t } = this.props
    const { profile, organization, edit } = this.state
    return (
      <>
        {this.state.modal}
        <div style={{ display: "flex", marginTop: 20 }}>
          <h2 style={{ marginRight: 5 }}>{t("profilePage")}</h2>{" "}
          <Info
            text={
              <div>
                <p>
                  {t(
                    "In this section you can see detailed information about the owner of this Smartkassa account",
                  )}
                </p>
              </div>
            }
          />
        </div>
        <Card style={{ width: "max-content", display: "inline-block" }}>
          <Card.Content>
            <Card.Header>{t("accountInormation")}: </Card.Header>
          </Card.Content>
          <Card.Content>
            <Table
              style={{
                border: "0px solid lightgray",
                boxShadow: "0px 0px #888888",
              }}
            >
              <Table.Body>
                <Table.Row>
                  <Table.Cell valign="top">
                    <b>{t("Login")}: </b>
                  </Table.Cell>
                  <Table.Cell>{profile.login}</Table.Cell>
                  <Table.Cell></Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell valign="top">
                    <b>{t("phoneNumber")}: </b>
                  </Table.Cell>
                  <Table.Cell>
                    {organization ? organization.phoneNumber : ""}
                  </Table.Cell>
                  {edit && 0 ? (
                    <Table.Cell onClick={() => this.drawModal("phoneNumber")}>
                      <Icon name="pencil" />
                    </Table.Cell>
                  ) : (
                    <Table.Cell></Table.Cell>
                  )}
                </Table.Row>
                <Table.Row>
                  <Table.Cell valign="top">
                    <b>Email: </b>
                  </Table.Cell>
                  <Table.Cell>
                    {organization ? organization.mail : ""}
                  </Table.Cell>
                  {edit && 0 ? (
                    <Table.Cell onClick={() => this.drawModal("mail")}>
                      <Icon name="pencil" />
                    </Table.Cell>
                  ) : (
                    <Table.Cell></Table.Cell>
                  )}
                </Table.Row>
                {false && (
                  <Table.Row>
                    <Table.Cell>
                      <b>{t("Change password")}</b>
                    </Table.Cell>
                    {edit ? (
                      <Table.Cell onClick={() => this.drawModal("password")}>
                        <Icon name="pencil" />
                      </Table.Cell>
                    ) : (
                      <Table.Cell></Table.Cell>
                    )}
                  </Table.Row>
                )}
              </Table.Body>
            </Table>
          </Card.Content>
        </Card>
        <Card.Group>
          <Card style={{ width: "max-content" }}>
            <Card.Content>
              <Card.Header>{t("companyInformation")}: </Card.Header>
            </Card.Content>
            <Card.Content>
              <Table
                style={{
                  border: "0px solid lightgray",
                  boxShadow: "0px 0px #888888",
                }}
              >
                <Table.Body>
                  <Table.Row>
                    <Table.Cell valign="top">
                      <b>{t("fullname")}: </b>
                    </Table.Cell>
                    <Table.Cell>
                      {organization ? organization.fio : ""}
                    </Table.Cell>
                    <Table.Cell>
                      <Table.Cell></Table.Cell>
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell valign="top">
                      <b>{`${t("UIN")}/${t("BIN")}`}: </b>
                    </Table.Cell>
                    <Table.Cell>
                      {organization ? organization.bin : ""}
                    </Table.Cell>
                    <Table.Cell></Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell valign="top">
                      <b>{t("organization")}: </b>
                    </Table.Cell>
                    <Table.Cell>
                      {organization ? organization.company : ""}
                    </Table.Cell>
                    <Table.Cell></Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell valign="top">
                      <b>{t("legalAddress")}: </b>
                    </Table.Cell>
                    <Table.Cell>
                      {organization ? organization.address : ""}
                    </Table.Cell>
                    <Table.Cell></Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell valign="top">
                      <b>{t("VAT")}: </b>
                    </Table.Cell>
                    <Table.Cell>
                      {organization ? organization.nds : ""}
                    </Table.Cell>
                    {edit && 0 ? (
                      <Table.Cell onClick={() => this.drawModal("nds")}>
                        <Icon name="pencil" />
                      </Table.Cell>
                    ) : (
                      <Table.Cell></Table.Cell>
                    )}
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell valign="top">
                      <b>{t("Signature")} </b>
                    </Table.Cell>
                    <Table.Cell>
                      {organization ? organization.comment : ""}
                    </Table.Cell>
                    {edit && 0 ? (
                      <Table.Cell onClick={() => this.drawModal("comment")}>
                        <Icon name="pencil" />
                      </Table.Cell>
                    ) : (
                      <Table.Cell></Table.Cell>
                    )}
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell valign="top">
                      <b>{t("taxOrgan")}: </b>
                    </Table.Cell>
                    <Table.Cell>
                      {organization ? organization.taxOffice : ""}
                    </Table.Cell>
                    <Table.Cell></Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell valign="top">
                      <b>{t("taxType")}: </b>
                    </Table.Cell>
                    <Table.Cell>
                      {organization ? organization.taxTypes : ""}
                    </Table.Cell>
                    <Table.Cell></Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table>
            </Card.Content>
          </Card>
          <Card style={{ width: "max-content" }}>
            <Card.Content>
              <Card.Header>{t("dataOnAvailableStores")}: </Card.Header>
            </Card.Content>
            <Card.Content>
              {organization && (
                <Table className="profile-table" style={{ border: "none" }}>
                  <Table.Body>
                    <Table.Row>
                      <Table.Cell>
                        <b>{t("stores")}: </b>
                      </Table.Cell>
                      <Table.Cell>
                        <Table style={{ border: "none" }} compact>
                          <Table.Body>
                            <Table.Row>
                              <Table.Cell>
                                <b>{t("storeName")}</b>
                              </Table.Cell>
                              <Table.Cell>
                                <b>{t("storeAddress")}</b>
                              </Table.Cell>
                            </Table.Row>
                            {profile ? (
                              profile.stores.map((store) => (
                                // eslint-disable-next-line react/jsx-key
                                <Table.Row>
                                  <Table.Cell key={store.id}>
                                    {store.name}
                                  </Table.Cell>
                                  <Table.Cell key={store.id}>
                                    {store.address}
                                  </Table.Cell>
                                </Table.Row>
                              ))
                            ) : (
                              <></>
                            )}
                          </Table.Body>
                        </Table>
                      </Table.Cell>
                    </Table.Row>
                  </Table.Body>
                </Table>
              )}
            </Card.Content>
          </Card>
        </Card.Group>
      </>
    )
  }
}
export default withTranslation()(ProfilePage)
